import {
  Box,
  Typography,
  type TypographyProps,
  useTheme,
} from 'hephaestus/web';
import { Card } from '../card/card';
import { useEmptyStateTokens } from './emptyState.tokens';

export const EmptyState = ({ children }: { children: any }) => {
  const theme = useTheme();
  const tokens = useEmptyStateTokens(theme);
  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: tokens.backgroundColor,
        borderRadius: tokens.borderRadius,
        borderColor: tokens.borderColor,
        borderWidth: '1px',
        borderStyle: 'dashed',
        textAlign: 'center',
      }}
    >
      {children}
    </Box>
  );
};

export const EmptyStateHeaderTitle = ({
  title,
  sx,
}: {
  title: string;
  sx?: TypographyProps['sx'];
}) => (
  <Typography variant='titleMedium' sx={[{ textAlign: 'center' }, sx as any]}>
    {title}
  </Typography>
);

export const EmptyStateAlt = ({
  title,
  subtitle,
  sx,
}: {
  title: string;
  subtitle?: string;
  sx?: any;
}) => (
  <Card
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      ...(sx ?? {}),
    }}
  >
    <EmptyStateHeaderTitle title={title} />
    {subtitle && (
      <Typography sx={{ mt: 0.5, fontWeight: 500 }} variant='bodyMedium'>
        {subtitle}
      </Typography>
    )}
  </Card>
);
